import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { Contrato, GenericResponse, SaveContratoDto, SearchContratoRequest, TipoContrato, ContratoAdjunto, ContratoPersona, SaveContratoMovimientoDto, ContratoUnidadFuncional } from "../model/index";
import { UploadContratoAttachResponseDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class ContratoService extends CrudService<Contrato, number, SaveContratoDto, SearchContratoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'contrato', sharedFunctions);

  }
  
  getTipos(): Observable<GenericResponse<TipoContrato[]>> {
    return this._http.get<GenericResponse<TipoContrato[]>>(this._serviceUrl + '/tipos', this.httpOptions);
  }

  getAttachments(id: number): Observable<GenericResponse<ContratoAdjunto[]>> {
    return this._http.get<GenericResponse<ContratoAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getPersonas(id: number): Observable<GenericResponse<ContratoPersona[]>> {
    return this._http.get<GenericResponse<ContratoPersona[]>>(this._serviceUrl + '/' + id + '/personas', this.httpOptions);
  }

  getUnidadesFuncionales(id: number): Observable<GenericResponse<ContratoUnidadFuncional[]>> {
    return this._http.get<GenericResponse<ContratoUnidadFuncional[]>>(this._serviceUrl + '/' + id + '/unidades-funcionales', this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadContratoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadContratoAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  crearMovimiento(p: SaveContratoMovimientoDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/crear-movimiento/'+p.ContratoId, p, this.httpOptions);
  }

  sendNewUserInvitation(p: ContratoPersona): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/send-new-user-invitation', p, this.httpOptions);
  }
}